import React from 'react';
import ReactDOM from 'react-dom';
import AccountExpireAlertModal from '../components/expireModal';

class ModalManager {
  constructor() {
    this.container = null;
    this.init();
  }

  init() {
    // 创建一个容器来挂载弹窗
    this.container = document.createElement('div');
    this.container.id = 'modal-manager-container';
    document.body.appendChild(this.container);
  }

  // 显示账户过期提醒弹窗
  showAccountExpireAlert(expireDate) {
    const ModalComponent = () => (
      <AccountExpireAlertModal 
        visible={true}
        expireDate={expireDate}
        onClose={() => this.hideAccountExpireAlert()}
      />
    );

    ReactDOM.render(<ModalComponent />, this.container);
  }

  // 隐藏账户过期提醒弹窗
  hideAccountExpireAlert() {
    if (this.container) {
      ReactDOM.unmountComponentAtNode(this.container);
    }
  }

  // 通用的弹窗显示方法
  show(component) {
    ReactDOM.render(component, this.container);
  }

  // 隐藏所有弹窗
  hide() {
    if (this.container) {
      ReactDOM.unmountComponentAtNode(this.container);
    }
  }

  // 销毁管理器
  destroy() {
    if (this.container) {
      ReactDOM.unmountComponentAtNode(this.container);
      document.body.removeChild(this.container);
      this.container = null;
    }
  }
}

// 创建全局实例
const modalManager = new ModalManager();

// 导出便捷方法
export const showAccountExpireAlert = (expireDate) => {
  modalManager.showAccountExpireAlert(expireDate);
};

export const hideAccountExpireAlert = () => {
  modalManager.hideAccountExpireAlert();
};

export const showModal = (component) => {
  modalManager.show(component);
};

export const hideModal = () => {
  modalManager.hide();
};

export default modalManager;